import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-bootstrap-date-picker';

class StaffsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      phone: '',
      celular_1: '',
      celular_2: '',
      date_of_birth: '',
      email: '',
      cpf: '',
      identity: '',
      id_uf: null,
      id_date: '',
      inscription: '',
      moodle_id: '',
      sigtrip_id: null,
      sigmec_id: null,
      sigtrip_staffs: [],
      sigmec_staffs: [],
      uf_birth: null,
      canac: '',
      agency: '',
      bank: '',
      account: '',
      pis: '',
      skip_tutor_payment: false,
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeIdDatePicker = this.handleChangeIdDatePicker.bind(this);
    this.handleChangeDateOfBirthPicker = this.handleChangeDateOfBirthPicker.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.loadExternalStaffs = this.loadExternalStaffs.bind(this);
    this.adicionar = this.adicionar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDateOfBirthPicker(value, formattedValue) {
    this.setState({
      date_of_birth: value,
      date_of_birth_str: formattedValue,
    });
  }
  handleChangeIdDatePicker(value, formattedValue) {
    this.setState({
      id_date: value,
      id_date_str: formattedValue,
    });
  }

  handleCheckboxChange(name, event) {
    var change = {};
    change[name] = event.target.checked;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
    this.loadExternalStaffs();
  }

  loadExternalStaffs() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      Promise.all([
        fetch(config.get('api') + '/sigtrip/colaboradores/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()),
        fetch(config.get('api') + '/sigmec/colaboradores/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()),
      ]).then(function(responses) {
        if (responses[0] && responses[0].status === 'success') {
          self.setState({sigtrip_staffs: responses[0].data});
        }
        if (responses[1] && responses[1].status === 'success') {
          self.setState({sigmec_staffs: responses[1].data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  adicionar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      phone: this.state.phone,
      celular_1: this.state.celular_1,
      celular_2: this.state.celular_2,
      date_of_birth: this.state.date_of_birth_str,
      email: this.state.email,
      cpf: this.state.cpf,
      identity: this.state.identity,
      id_uf: this.state.id_uf,
      id_date: this.state.id_date_str,
      inscription: this.state.inscription,
      moodle_id: this.state.moodle_id,
      sigtrip_id: this.state.sigtrip_id,
      sigmec_id: this.state.sigmec_id,
      uf_birth: this.state.uf_birth,
      canac: this.state.canac,
      agency: this.state.agency,
      bank: this.state.bank,
      account: this.state.account,
      pis: this.state.pis,
      instrutor: '0',
      skip_tutor_payment: this.state.skip_tutor_payment ? 1 : 0,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alunos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/aluno/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar Aluno</h3>
      <Link to="/alunos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <h4>Informações Pessoais</h4>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" required className="form-control" placeholder="Seu nome" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>E-mail:</label>
              <input type="text" name="email" className="form-control" placeholder="E-mail do Aluno/Instrutor" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nascimento:</label>
              <DatePicker onChange={this.handleChangeDateOfBirthPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de Nascimento" value={this.state.date_of_birth} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>UF Nascimento:</label>
              <Select
                className="form-field-name"
                name="uf_birth"
                value={this.state.uf_birth}
                searchable={true}
                placeholder={'UF de Nascimento'}
                onChange={this.handleSelectChange.bind(this, 'uf_birth')}
                options={[
                  {value: "AC", label: "Acre"},
                  {value: "AL", label: "Alagoas"},
                  {value: "AM", label: "Amazonas"},
                  {value: "AP", label: "Amapá"},
                  {value: "BA", label: "Bahia"},
                  {value: "CE", label: "Ceará"},
                  {value: "DF", label: "Distrito Federal"},
                  {value: "ES", label: "Espírito Santo"},
                  {value: "GO", label: "Goiás"},
                  {value: "MA", label: "Maranhão"},
                  {value: "MT", label: "Mato Grosso"},
                  {value: "MS", label: "Mato Grosso do Sul"},
                  {value: "MG", label: "Minas Gerais"},
                  {value: "PA", label: "Pará"},
                  {value: "PB", label: "Paraíba"},
                  {value: "PR", label: "Paraná"},
                  {value: "PE", label: "Pernambucano"},
                  {value: "PI", label: "Piauí"},
                  {value: "RJ", label: "Rio de Janeiro"},
                  {value: "RN", label: "Rio Grande do Norte"},
                  {value: "RO", label: "Rondônia"},
                  {value: "RS", label: "Rio Grande do Sul"},
                  {value: "RR", label: "Roraima"},
                  {value: "SC", label: "Santa Catarina"},
                  {value: "SE", label: "Sergipe"},
                  {value: "SP", label: "São Paulo"},
                  {value: "TO", label: "Tocantins"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Telefone:</label>
              <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do Aluno/Instrutor" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Celular 1:</label>
              <InputMask value={this.state.celular_1}  maskChar={null} name="celular_1" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'celular_1')} placeholder="Celular 1 do Aluno/Instrutor" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Celular 2:</label>
              <InputMask value={this.state.celular_2}  maskChar={null} name="celular_2" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'celular_2')} placeholder="Celular 2 do Aluno/Instrutor" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={this.state.skip_tutor_payment}
                  onChange={this.handleCheckboxChange.bind(this, 'skip_tutor_payment')}
                />
                {' '}Não gerar pagamento de tutor automaticamente
              </label>
              <small className="help-block">
                Marque para impedir que este colaborador seja incluído no processamento automático de pagamentos de tutor.
              </small>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>CPF:</label>
              <InputMask value={this.state.cpf}  maskChar={null} name="cpf" mask="999.999.999-99" className="form-control" onChange={this.handleChange.bind(this, 'cpf')} placeholder="CPF do Aluno/Instrutor" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Identidade:</label>
              <input type="text" name="identity" className="form-control" placeholder="Identidade do Aluno/Instrutor" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>ID UF:</label>
              <Select
                className="form-field-name"
                name="id_uf"
                value={this.state.id_uf}
                searchable={true}
                placeholder={'UF da identidade do Aluno/Instrutor'}
                onChange={this.handleSelectChange.bind(this, 'id_uf')}
                options={[
                  {value: "AC", label: "Acre"},
                  {value: "AL", label: "Alagoas"},
                  {value: "AM", label: "Amazonas"},
                  {value: "AP", label: "Amapá"},
                  {value: "BA", label: "Bahia"},
                  {value: "CE", label: "Ceará"},
                  {value: "DF", label: "Distrito Federal"},
                  {value: "ES", label: "Espírito Santo"},
                  {value: "GO", label: "Goiás"},
                  {value: "MA", label: "Maranhão"},
                  {value: "MT", label: "Mato Grosso"},
                  {value: "MS", label: "Mato Grosso do Sul"},
                  {value: "MG", label: "Minas Gerais"},
                  {value: "PA", label: "Pará"},
                  {value: "PB", label: "Paraíba"},
                  {value: "PR", label: "Paraná"},
                  {value: "PE", label: "Pernambucano"},
                  {value: "PI", label: "Piauí"},
                  {value: "RJ", label: "Rio de Janeiro"},
                  {value: "RN", label: "Rio Grande do Norte"},
                  {value: "RO", label: "Rondônia"},
                  {value: "RS", label: "Rio Grande do Sul"},
                  {value: "RR", label: "Roraima"},
                  {value: "SC", label: "Santa Catarina"},
                  {value: "SE", label: "Sergipe"},
                  {value: "SP", label: "São Paulo"},
                  {value: "TO", label: "Tocantins"},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>ID Expedição:</label>
              <DatePicker onChange={this.handleChangeIdDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Expedição da identidade do Aluno/Instrutor" value={this.state.id_date} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Agência bancária:</label>
              <input type="text" name="agency" className="form-control" placeholder="Agência" value={this.state.agency} onChange={this.handleChange.bind(this, 'agency')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>PIS:</label>
              <input type="text" name="pis" className="form-control" placeholder="PIS" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>C/C:</label>
              <input type="text" name="account" className="form-control" placeholder="Conta corrente" value={this.state.account} onChange={this.handleChange.bind(this, 'account')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Banco:</label>
              <input type="text" name="bank" className="form-control" placeholder="Banco" value={this.state.bank} onChange={this.handleChange.bind(this, 'bank')} />
            </div>
          </div>
        </div>
        <hr />
        <h4>Informações Profissionais</h4>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>CANAC:</label>
              <InputMask value={this.state.canac}  maskChar={null} name="canac" mask="999999" className="form-control" onChange={this.handleChange.bind(this, 'canac')} placeholder="CANAC do Aluno/Instrutor" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Matrícula:</label>
              <input type="text" name="inscription" className="form-control" placeholder="Matrícula do Aluno/Instrutor" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Moodle ID:</label>
              <input type="text" name="moodle_id" className="form-control" placeholder="Id no moodle" value={this.state.moodle_id} onChange={this.handleChange.bind(this, 'moodle_id')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Vínculo SIGTRIP:</label>
              <Select
                className="form-field-name"
                name="sigtrip_id"
                value={this.state.sigtrip_id}
                searchable={true}
                clearable={true}
                placeholder={'Colaborador SIGTRIP'}
                onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
                options={this.state.sigtrip_staffs}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Vínculo SIGMEC:</label>
              <Select
                className="form-field-name"
                name="sigmec_id"
                value={this.state.sigmec_id}
                searchable={true}
                clearable={true}
                placeholder={'Colaborador SIGMEC'}
                onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
                options={this.state.sigmec_staffs}
              />
            </div>
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar Aluno</button>
      </form>
      </div>
  </div>
</div>
    );
  }
}

export default StaffsAdd;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsAdd.js